// extracted by mini-css-extract-plugin
module.exports = {"pressItem":"Press_pressItem__sHlsu"};